import { useState } from "react";
import { ArrowDown, ArrowUpRight } from "lucide-react";
import { whatsappLink } from "@/App";
import { commercialConfig } from "@/config/commercialConfig";

const heroImage = "https://www.poggibros.it/wp-content/uploads/2021/03/classico-D-cf_44A1098-1.jpg";

export default function HeroSection({ onQuote }) {
  const [pointer, setPointer] = useState({ x: 0, y: 0 });

  const handleMove = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setPointer({ x: ((event.clientX - rect.left) / rect.width - 0.5) * 10, y: ((event.clientY - rect.top) / rect.height - 0.5) * 10 });
  };

  return (
    <section className="hero-section" id="top" data-testid="hero-kinetic-section">
      <div className="site-container hero-grid">
        <div className="hero-copy">
          <div className="hero-kicker reveal"><span className="eyebrow-dot" /> <span>StoneInLove / archivio 01</span></div>
          <h1 className="hero-title" data-testid="hero-title-masked">
            <span className="hero-line-mask"><span className="hero-line">La pietra eterna</span></span>
            <span className="hero-line-mask"><span className="hero-line">dell'architettura</span></span>
            <span className="hero-line-mask hero-line-accent"><span className="hero-line">romana contemporanea.</span></span>
          </h1>
          <div className="hero-lower reveal reveal-delay-3">
            <p className="hero-intro">Travertini romani selezionati a Tivoli, per chi pensa gli spazi come opere destinate a restare.</p>
            <div className="hero-actions">
              <button className="button button-dark" type="button" onClick={onQuote} data-testid="hero-cta-quote-btn">Calcola il tuo progetto <ArrowUpRight size={16} /></button>
              <a className="button button-line" href={whatsappLink()} target="_blank" rel="noreferrer" data-testid="hero-cta-whatsapp-btn">Parla con SIL <span>↗</span></a>
            </div>
          </div>
          <div className="hero-footnote reveal reveal-delay-4"><span>LAT 41°57'N / LON 12°47'E</span><span>EST. TIVOLI / ROMA</span></div>
        </div>
        <div className="hero-visual-column reveal reveal-delay-2">
          <div className="hero-coordinate-top">TIVOLI STONE RESERVE <span>— 001</span></div>
          <div className="hero-image-frame" onMouseMove={handleMove} onMouseLeave={() => setPointer({ x: 0, y: 0 })}>
            <img src={heroImage} alt="Superficie in travertino romano chiaro" style={{ transform: `translate3d(${pointer.x}px, ${pointer.y}px, 0) scale(1.04)` }} />
            <span className="hero-image-stamp">TRAVERTINO<br /><em>ROMANO</em></span>
          </div>
          <div className="hero-visual-meta"><span>01 / 06</span><span>PORO NATURALE · CLASSICO D</span><span>SPOTLIGHT STUDY</span></div>
          <div className="hero-status"><span className="status-pulse" /> <strong>{commercialConfig.availability.value}</strong><span>{commercialConfig.availability.label}</span></div>
        </div>
      </div>
      <a className="hero-scroll" href="#manifesto" data-testid="hero-scroll-link"><ArrowDown size={15} /> Scorri per entrare nell'archivio</a>
    </section>
  );
}
